import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { ports } from "@/mocks/home";

export default function PortsSection() {
  return (
    <section id="ports" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-apps-2-line"></i>
            五大业务端口
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            五大端口，构建产业共生闭环
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 max-w-2xl mx-auto leading-relaxed">
            从乡村种植到城市改造，从认种到体验，一个平台打通农业、文旅、社交与城市生活的完整链路。
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ports.map((port, i) => {
            const inner = (
              <>
                <div className="flex items-start justify-between">
                  <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
                    <i className={`${port.icon} text-2xl`}></i>
                  </span>
                  <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
                    {port.tag}
                  </span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mt-5">
                  {port.title}
                </h3>
                <p className="text-xs text-primary-600 font-medium mt-1">{port.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">{port.desc}</p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium mt-4 group-hover:gap-2 transition-all">
                  了解详情
                  <i className="ri-arrow-right-line"></i>
                </span>
              </>
            );

            return (
              <Reveal key={port.id} delay={i * 80}>
                {port.href.startsWith("/") ? (
                  <Link
                    to={port.href}
                    className="group block h-full bg-white rounded-lg border border-background-200 p-6 md:p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-300 cursor-pointer"
                  >
                    {inner}
                  </Link>
                ) : (
                  <a
                    href={port.href}
                    className="group block h-full bg-white rounded-lg border border-background-200 p-6 md:p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-300 cursor-pointer"
                  >
                    {inner}
                  </a>
                )}
              </Reveal>
            );
          })}

          <Reveal delay={400}>
            <Link
              to="/adopt"
              className="group flex h-full flex-col items-center justify-center bg-primary-500 rounded-lg p-8 text-center transition-all duration-300 hover:-translate-y-1.5 hover:bg-primary-600 cursor-pointer"
            >
              <span className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center">
                <i className="ri-seedling-line text-2xl text-white"></i>
              </span>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-white mt-5">
                从认种一块田开始
              </h3>
              <p className="text-sm text-white/85 mt-3 leading-relaxed">
                进入你的专属主题园，开启田园共生之旅
              </p>
              <span className="inline-flex items-center gap-1.5 text-white text-sm font-medium mt-5 group-hover:gap-3 transition-all">
                立即认种
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}